<div *ngIf="company" class="clr-row">
  <div class="clr-col-5">
    <div class="clr-row">
      <div class="clr-col-6">
        <span>Kunde</span>
      </div>
      <div  class="clr-col-1">
        <cds-icon shape="note" [routerLink]="['/contact/details', company.cid ]"></cds-icon>
      </div>
      <div class="clr-col-5">
        {{ company.company }}<br>
        {{ company.street }}<br>
        {{ company.postcode }} {{ company.city }}
      </div>
    </div>
    <div class="clr-row">
      <div class="clr-col-6">
        <span>Ansprechpartner beim Kunden</span>
      </div>
      <div class="clr-col-1">
        <span *ngIf="person"><cds-icon shape="note" [routerLink]="['/person/details', person.pid ]"></cds-icon></span>
      </div>
      <div class="clr-col-5">
        <span *ngIf="person">{{ person.salutation }} {{ person.firstname }} {{ person.lastname }}</span>
        <span *ngIf="!person">Ansprechpartner im TecArt wahrscheinlich gelöscht...</span>
      </div>
    </div>
    <div class="clr-row">
      <div class="clr-col-6">
        <span>Projektnummer des Kunden</span>
      </div>
      <div class="clr-col-1"></div>
      <div class="clr-col-5">
        {{ basedata?.request_id }}
      </div>
    </div>
    <div class="clr-row" *ngIf="requestFiles.length > 0">
      <div class="clr-col-6">
        <span>Anfragen des Kunden</span>
      </div>
      <div class="clr-col-1"></div>
      <div class="clr-col-5">
        <table class="table table-compact">
          <tbody>
          <tr *ngFor="let requestFile of requestFiles">
            <td><cds-icon shape="file" size="l" *ngIf="requestFile.fileType === 'application/pdf'" (click)="showModal(requestFile.id)"></cds-icon></td>
            <td class="left">{{ requestFile.description }}</td>
            <td class="left">{{ requestFile.fileName }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="clr-col-7">
    <div class="clr-row">
      <div class="clr-col-2">
        <h4>Kommentare</h4>
      </div>
      <div class="clr-col-10">
        <h4>...zum Projekt</h4>
        <app-comment-feature-card [projectId]=project_id [companyId]=company.cid [staffId]=basedata?.employee_phm [subId]=0 [commentType]=9></app-comment-feature-card>
        <h4>...im Kontext zum Projekt</h4>
        <app-comment-project-card [projectId]=project_id></app-comment-project-card>
      </div>
    </div>
  </div>


</div>
<br />
<div class="btn-group btn-sm btn-primary">
  <button *ngIf="!!company" class="btn" [routerLink]="['/project/update', company.cid, pridstd]">Projekt bearbeiten</button>
  <button *ngIf="!!company" class="btn" (click)="basic = true; createMemo(positions)">Memo</button>
  <button class="btn btn-danger" (click)="deleteProject()">Projekt löschen</button>
</div>

<clr-modal *ngIf="!!company" [(clrModalOpen)]="basic" [clrModalSize]="'xl'">
  <h3 class="modal-title">MEMO {{ company.cid }}.{{ pridstd }}</h3>
  <div id="documentContainer" class="modal-body"></div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="basic = false">Zurück</button>
    <button type=“button” class="btn btn-primary" (click)="downloadPdf(); basic = false">Download</button>
    <button type="button" class="btn btn-primary" (click)="printPdf(); basic = false">Drucken</button>
  </div>
</clr-modal>

<ng-container *ngIf="showPDF">
  <clr-modal id="pdfViewer" [(clrModalOpen)]="showPDF" [clrModalStaticBackdrop]="false">
    <h3 class="modal-title">{{ modalContent }}</h3>
    <div class="modal-body">
      <ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
    </div>
  </clr-modal>
</ng-container>
